import { render, staticRenderFns } from "./BeLanguageButton.vue?vue&type=template&id=67652b2b&scoped=true"
import script from "./BeLanguageButton.vue?vue&type=script&lang=js"
export * from "./BeLanguageButton.vue?vue&type=script&lang=js"
import style0 from "./BeLanguageButton.vue?vue&type=style&index=0&id=67652b2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67652b2b",
  null
  
)

export default component.exports